import React, { useEffect, useRef, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Input } from "reactstrap";

const FilterSuperAdmin = ({
  isDropdownOpen,
  setIsDropdownOpen,
  setActiveColumns,
  allColumns,
  selectedOptions,
  setSelectedOptions
}) => {
  // Default columns to show (a subset of all available columns)
  const defaultColumns = [
    "srNo",
    "organizationName",
    "organizationId",
    "mobileNumber",
    "createdAt",
    "selectedPlan",
    "status",
    "actions",
    "isLeadEnable",
    "salesPerson"
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Initialize with default columns on first render
  useEffect(() => {
    if (selectedOptions.length === allColumns.length) {
      setSelectedOptions(defaultColumns);
      updateActiveColumns(defaultColumns);
    }
  }, []);

  // Handle toggle of dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Handle selection/deselection of columns
  const handleOptionChange = (columnId, e) => {
    if (e) {
      e.stopPropagation();
    }

    let updatedSelection;

    // If column is already selected, remove it unless it would result in empty selection
    if (selectedOptions.includes(columnId)) {
      if (selectedOptions.length > 1) {
        updatedSelection = selectedOptions.filter(id => id !== columnId);
      } else {
        // Don't allow deselecting the last column
        return;
      }
    } else {
      // Add column to selection
      updatedSelection = [...selectedOptions, columnId];
    }

    setSelectedOptions(updatedSelection);
    updateActiveColumns(updatedSelection);
  };

  // Update active columns based on selected options
  const updateActiveColumns = (selected) => {
    const filteredColumns = allColumns.filter(col => selected.includes(col.id));
    setActiveColumns(filteredColumns);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    e.stopPropagation();
    setSearchTerm(e.target.value.toLowerCase());
  };

  // Filter columns based on search term
  const filteredColumns = allColumns.filter(column => {
    const columnName = column.name.props?.children || column.name;
    return columnName.toString().toLowerCase().includes(searchTerm);
  });

  // Handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [setIsDropdownOpen]);

  return (
    <div className="column-filter-container" ref={dropdownRef}>
      <Dropdown isOpen={isDropdownOpen} toggle={toggleDropdown} direction="down">
        <DropdownToggle tag="div">
          <Button className="btn btn-danger mt-3">
            <i className="ri-filter-line"></i>
          </Button>
        </DropdownToggle>
        <DropdownMenu className="column-filter-dropdown" onClick={(e) => e.stopPropagation()}>
          {/* Search input */}
          <div className="px-2 ">
            <Input
              type="text"
              placeholder="Search columns..."
              value={searchTerm}
              onChange={handleSearchChange}
              onClick={(e) => e.stopPropagation()}
              className="form-control form-control-sm"
            />
          </div>
          <DropdownItem divider />
                  
          {/* Column options */}
          <div className="column-options-container" style={{ maxHeight: "300px", overflowY: "auto" }}>
            {filteredColumns.length > 0 ? (
              filteredColumns.map((column) => (
                <div key={column.id} className="column-option px-3 py-2">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`col-${column.id}`}
                      checked={selectedOptions.includes(column.id)}
                      onChange={(e) => handleOptionChange(column.id, e)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label 
                      className="form-check-label w-100 cursor-pointer" 
                      htmlFor={`col-${column.id}`}
                      style={{ cursor: 'pointer' }}
                    >
                      {column.name.props?.children || column.name}
                    </label>
                  </div>
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-center text-muted">
                No columns match your search
              </div>
            )}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default FilterSuperAdmin;